module.exports = __webpack_public_path__ + "static/box-84167c2c5f53ce2c4c6efe515a64219e.gif";